<template>
  <cs-preloader-overlay :loading="loading">
    <div class="widget-container">
      <div class="widget-list-container">
        <goal-widget-card
          v-for="widget in getDonationGoal"
          :key="widget.id"
          :widget="widget"
          @edit="onShownForm(widget)"
          @remove="onRemoveWidget"
          @status="onChangeStatusWidget"
        />
        <add-goal-widget-card v-if="isDesktop" @click="onShownForm" />
        <circle-button v-else @click="onShownForm" />
      </div>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { mapGetters } from 'vuex';

import CircleButton from '../components/CircleButton';
import AddGoalWidgetCard from '../components/AddGoalWidgetCard';
import GoalWidgetCard from '../components/GoalWidgetCard';

export default {
  name: 'GoalList',
  components: {
    CircleButton,
    AddGoalWidgetCard,
    GoalWidgetCard,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['isDesktop']),
    ...mapGetters('streamerWidgets', ['getDonationGoal']),
  },
  watch: {
    getDonationGoal: {
      immediate: true,
      handler: 'checkPermission',
    },
  },
  methods: {
    checkPermission(widgets) {
      this.loading = true;

      if (this.$validate.isEmptyArray(widgets)) {
        this.$router.push({ name: 'streamer.widgets.goal.form' });
        return;
      }

      this.loading = false;
    },
    onShownForm(widget) {
      if (!widget) {
        this.$router.push({ name: 'streamer.widgets.goal.form' });
        return;
      }

      this.$router.push({
        name: 'streamer.widgets.goal.form',
        query: { code: widget.code },
      });
    },
    onSumbitForm(data) {
      this.$emit('submit', data);
    },
    onRemoveWidget(data) {
      this.$emit('remove', data);
    },
    onChangeStatusWidget(data) {
      this.$emit('change-status', data);
    },
  },
};
</script>

<style lang="sass" scoped>
  .widget-container
    display: flex

    +respond-to(medium)
      justify-content: center

  .widget-list-container
    display: flex
    flex-grow: 1
    flex-wrap: wrap
    margin: -10px 10px

    +respond-to(small)
      margin: -10px

    +respond-to(medium)
      flex-grow: 0
</style>
